import { Breakpoint } from '@lendi-ui/breakpoint';

export const Resolution = {
  at1x: {
    dpi: '0.001dpi',
    dppx: '1dppx',
  },
  at2x: {
    dpi: '192dpi',
    dppx: '2dppx',
  },
};

export const mediaQueries = {
  mobile1x: `(min-width: ${Breakpoint.mobile}) and (min-resolution: ${Resolution.at1x.dpi}),
    (min-width: ${Breakpoint.mobile}) and (min-resolution: ${Resolution.at1x.dppx})`,
  mobile2x: `(min-width: ${Breakpoint.mobile}) and (min-resolution: ${Resolution.at2x.dpi}),
    (min-width: ${Breakpoint.mobile}) and (min-resolution: ${Resolution.at2x.dppx})`,
  tablet1x: `(min-width: ${Breakpoint.tablet}) and (min-resolution: ${Resolution.at1x.dpi}),
    (min-width: ${Breakpoint.tablet}) and (min-resolution: ${Resolution.at1x.dppx})`,
  tablet2x: `(min-width: ${Breakpoint.tablet}) and (min-resolution: ${Resolution.at2x.dpi}),
    (min-width: ${Breakpoint.tablet}) and (min-resolution: ${Resolution.at2x.dppx})`,
  desktop1x: `(min-width: ${Breakpoint.desktop}) and (min-resolution: ${Resolution.at1x.dpi}),
    (min-width: ${Breakpoint.desktop}) and (min-resolution: ${Resolution.at1x.dppx})`,
  desktop2x: `(min-width: ${Breakpoint.desktop}) and (min-resolution: ${Resolution.at2x.dpi}),
    (min-width: ${Breakpoint.desktop}) and (min-resolution: ${Resolution.at2x.dppx})`,
};
